import {useState} from 'react';

import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';

import FormInput from '../common/FormInput';
import FindReferrerCompanyInput from './FindReferrerCompanyInput';

import {getReferralSourceCategories} from '../../helpers/selectOptions';
import {useCreateReferrerMutation} from '../../redux/services/referrerApi';

const getFields = () => ([
  {
    name: 'name',
    label: 'Name',
    type: 'text',
    required: true,
    validate: val => true,
    placeholder: 'Enter referrer name',
  },
  {
    name: 'category',
    label: 'Referral Type',
    type: 'select',
    required: true,
    validate: val => true,
    options: getReferralSourceCategories(),
  },
  {
    name: 'company_id',
    label: 'Referrer Company',
    type: 'custom',
    validate: val => true,
    allowCreateNew: true,
    component: FindReferrerCompanyInput,
  }
]);

const parseFormValues = values => values;

const handleFieldUpdate = ({formValues, setFormValues}) => name => (e,  val) => {
  const value = val ? val : (e.target ? e.target.value : null);
  setFormValues({
    ...formValues,
    [name]: value,
  });
};

const handleSubmit = ({post, afterSubmit}) => async (e, formValues) => {
  const body = parseFormValues(formValues);
  const response = await post(body);
  if (response.error) {
    console.error('Error creating referrer:', response.error);
    return;
  }
  if (afterSubmit) afterSubmit(e, response.data.id);
};

const getDefaultFormValues = () => ({
  name: '',
  category: null,
  referrer_company_id: null,
});

const ReferrerForm = props => {
  const defaultValues = getDefaultFormValues();
  const [formValues, setFormValues] = useState(defaultValues);
  const [post, response] = useCreateReferrerMutation();
  const fields = getFields();
  const onFieldUpdate = handleFieldUpdate({formValues, setFormValues});
  const onSubmit = handleSubmit({post, formValues, afterSubmit: props.afterSubmit});
  return (
    <Stack gap={1}>
      {
        response.error && <Alert severity='error'>
          Error creating referrer: {response.error.message}
        </Alert>
      }
      {fields.map(f => 
        f.type === 'custom' ? (
          <f.component
            key={f.name}
            name={f.name}
            label={f.label}
            validate={f.validate}
            defaultValue={defaultValues?.[f.name] || f?.defaultValue}
            onChange={onFieldUpdate(f.name)}
            allowCreateNew={f.allowCreateNew}
            {...props}
            onSubmit={f.name === 'company_id' ? onFieldUpdate(f.name) : undefined}
          />
        ) : (
          <FormInput
            {...f}
            defaultValue={defaultValues?.[f.name] || f.defaultValue}
            onChange={onFieldUpdate(f.name)}
          />
        )
      )}
      <Button
        variant='primaryGradient'
        disabled={response.isLoading}
        onClick={e => onSubmit(e, formValues)}
      >
        Save
      </Button>
    </Stack>
  );
};

export default ReferrerForm;